import React, { useEffect, useRef, useState } from "react";
import PopupUI from "./popupUI";
import { useThemeMode } from "../../../context/contextTheme";
import { wsNotify } from "../../../api/ws/ws-notify";
import { getLogs } from "../../../api/get/get-log";
import { useAuth } from "../../../context/contextAuth";
import "./style.css";

const BellIcon = () => {
  const { theme } = useThemeMode();
  const { d_id, userId } = useAuth();
  const [showNotify, setShowNotify] = useState(false);
  const [notifyCount, setNotifyCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const logs = await getLogs(d_id);
        if (Array.isArray(logs)) {
          const sorted = logs
            .map((n) => ({
              ...n,
              title: n.title || "Notification",
              timestamp: n.timestamp || Date.now(),
              level: n.level || "info",
              message: n.message || "Notification",
              isNew: false,
            }))
            .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

          setNotifications(sorted);
          setNotifyCount(0);
        }
      } catch (error) {
        console.error("❌ Error fetching notifications:", error);
      }
    };

    if (userId) fetchNotifications();
  }, [userId, d_id]);

  useEffect(() => {
    const ws = wsNotify();
    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        // console.log("📩 New WS notification:", data);

        setNotifications((prev) => {
          const updated = [
            {
              ...data,
              title: data.title || "Notification",
              timestamp: data.timestamp || Date.now(),
              isNew: true,
            },
            ...prev.map((n) => ({ ...n, isNew: false })),
          ];

          if (!showNotify) setNotifyCount((prevCount) => prevCount + 1);
          return updated;
        });
      } catch (err) {
        console.error("❌ Invalid WS message:", err);
      }
    };

    ws.onerror = (err) => console.error("⚠️ WebSocket Error:", err);

    return () => {
      if (
        ws.readyState === WebSocket.OPEN ||
        ws.readyState === WebSocket.CONNECTING
      ) {
        ws.close();
      }
    };
  }, [showNotify]);

  const handleClick = () => {
    setShowNotify((prev) => {
      const newState = !prev;
      if (newState) setNotifyCount(0);
      return newState;
    });
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowNotify(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className="dropdown position-relative">
      <button
        className="btn btn-secondary bg-transparent border-0 position-relative"
        type="button"
        onClick={handleClick}
      >
        <i
          className="bi bi-bell-fill bellIcon"
          style={{ fontSize: "1.5rem", color: theme.textColor }}
        />
        {notifyCount > 0 && (
          <span
            className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
            style={{ marginTop: 9, marginLeft: -9 }}
          >
            {notifyCount}
            <span className="visually-hidden">unread messages</span>
          </span>
        )}
      </button>

      {showNotify && (
        <PopupUI
          notifications={notifications}
          setNotifications={setNotifications}
          setNotifyCount={setNotifyCount}
        />
      )}
    </div>
  );
};

export default BellIcon;